import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";
const MultiInputTag = ({
  label,
  length,
  name,
  icon,
  defaultValue,
  type,
  required,
  noDropdown,
}) => {
  const [visibility, setVisibility] = useState(true);

  const icons = [
    "facebook",
    "instagram",
    "twitter",
    "linkedin",
    "github",
    "website",
  ];

  const handleDelete = (event) => {
    setVisibility(false);
  };
  return (
    <div
      key={Math.random()}
      className={`${
        visibility ? "flex gap-1 items-end" : "gap-1 items-end hidden"
      } ${noDropdown && "mb-2 items-center"}`}
    >
      <div>
        {!noDropdown && (
          <label className="label">
            <span className="text-md font-semibold">
              {length ? label + " " + length : label}
            </span>
          </label>
        )}
        <label className={`input-group`}>
          {noDropdown ? (
            <span className="border border-gray-900 border-r-0 whitespace-nowrap bg-gray-200">
              {length ? label + " " + length : label}
            </span>
          ) : (
            <select
              selected
              className="select select-bordered bg-[#3D4451] text-white uppercase"
            >
              <option disabled selected>
                {icon}
              </option>
              {icons
                .filter((item) => item !== icon)
                .map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
            </select>
          )}
          <input
            name={visibility ? name : ""}
            defaultValue={defaultValue}
            type={type}
            className={`input input-bordered w-full z-0`}
            required={required}
          />
        </label>
      </div>
      <div>
        <button
          type="button"
          onClick={handleDelete}
          className="btn  btn-sm btn-circle"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default MultiInputTag;
